import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { CampaignIcon } from 'components/Atoms/Icon';
import { isMobile } from 'utilities/common';
import { USER_LEVEL_TYPE } from 'constants/common';
import { t } from 'utilities/lang';

const CreateCampaign = lazy(() => import('components/Pages/Campaign/Create'));
const CampaignList = lazy(() => import('components/Pages/Campaign/List'));
const CampaignSnapshot = lazy(() =>
  import('components/Pages/CampaignSnapshot')
);
const CampaignDetail = lazy(() => import('components/Pages/Campaign/Detail'));
const CampaignReview = lazy(() =>
  import('components/Pages/Campaign/List/components/ReviewCampaign')
);

export const campaignRoutes = [
  {
    path: routePath.CAMPAIGNS,
    component: CampaignList,
    exact: true,
    showMenu: true,
    name: `${t('route.my')} ${routeName.CAMPAIGN}s`,
    icon: CampaignIcon,
    breadcrumbs: [{ name: routeName.CAMPAIGN }],
    mobile: true,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_CAMPAIGN.replace(':step', 'step1'),
    component: CreateCampaign,
    exact: false,
    showMenu: false,
    name: routeName.CAMPAIGN,
    icon: CampaignIcon,
    breadcrumbs: [],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CAMPAIGN_SNAPSHOT,
    component: CampaignSnapshot,
    exact: true,
    parentName: `${t('route.my')} ${routeName.CAMPAIGN}s`,
    breadcrumbs: [
      { name: routeName.CAMPAIGN, link: routePath.CAMPAIGNS },
      { name: t('route.campaign_snapshot') },
    ],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CREATE_DRAFT_CAMPAIGN,
    component: CreateCampaign,
    exact: true,
    showMenu: false,
    name: t('route.new_campaign'),
    icon: CampaignIcon,
    breadcrumbs: [],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.EDIT_CAMPAIGN,
    component: CreateCampaign,
    exact: true,
    showMenu: false,
    name: `${t('route.my')} ${routeName.CAMPAIGN}s`,
    icon: CampaignIcon,
    breadcrumbs: [],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.CAMPAIGN_DETAIL,
    component: isMobile ? CampaignDetail : CampaignReview,
    exact: true,
    showMenu: false,
    breadcrumbs: [
      { name: routeName.CAMPAIGN, link: routePath.CAMPAIGNS },
      { name: routeName.CAMPAIGN_REVIEW },
    ],
    mobile: true,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
